import { CertificateForm } from 'front-office/components/released-services/form';
import { DateTime } from 'luxon';
import { UserProfile } from 'shell/hooks/use-user-profile/types';
import { CertificateWithourJustificationPdfRequest } from 'shell/models/certificate';
export const tranformCertificatePdfWithourJustificationRequest = (
  userProfile: UserProfile,
  form?: CertificateForm
): CertificateWithourJustificationPdfRequest => {
  const {
    stamp = '0.0',
    secretary = '0.0',
    civilStatus = '0.0',
    fixed = '0.0',
    refund = '0.0',
  } = form || {};

  const importi =
    Number(stamp) + Number(secretary) + Number(civilStatus) + Number(fixed) + Number(refund);

  const numeroServizio = `${form?.acronym}-${form?.year}-${form?.progressive}`;

  return {
    codiceDocumento: form?.documentCode || '',
    descrizioneDocumento: form?.description || '',
    comune: userProfile?.datiLogin?.nome || '',
    nomeOperatore: form?.emitted || '',
    descrizioneServizio: form?.service || '',
    dataStampa: DateTime.now().toFormat('dd/MM/yyyy') || '',
    numeroServizio: numeroServizio || '',
    dataEmissione: form?.dateForm?.toFormat('dd/MM/yyyy') || '',
    cfIntestatario: form?.holderFiscalCode || '',
    importo: importi?.toString() || '',
    motivoMancataStampa: form?.serviceVoidReason || '',
  };
};
